<template>
  <div class="conv-card">

    <!-- Header -->
    <div class="header">
      <div class="left">
        <span class="id">#{{ c.conversation_id }}</span>
        <span class="pill" :class="c.status">{{ c.status }}</span>
        <span class="pill" :class="c.status">{{ c.dispo_status }}</span>
      </div>

      <div class="right">
        {{ c.assigned_username ? '@' + c.assigned_username : "Unassigned" }}
      </div>
    </div>

    <!-- User Info -->
    <div class="user">
      {{ c.visitor_name || "Visitor" }}
      <span v-if="c.visitor_phone">• {{ c.visitor_phone }}</span>
    </div>

    <!-- Form JSON (optional) -->
    <div class="meta" v-if="c.form_json">
      {{ c.form_json }}
    </div>

    <!-- Last Message -->
    <div class="message" v-if="c.last_message">
      {{ c.last_message }}
    </div>

    <!-- Actions -->
    <div class="actions">
      <button class="secondary" @click="$emit('view', c)">
        View Chat
      </button>

      <select
        v-if="c.status != 'CLOSED'"
        v-model="localAssign"
        :disabled="c.status === 'CLOSED'"
      >
        <option value="">Assign to…</option>
        <option v-for="a in agents" :key="a.id" :value="a.id">
        {{ `${a.username} (${a.state})` }}
        </option>
        

      </select>

      <button
        v-if="c.status != 'CLOSED'"
        @click="assign"
        :disabled="c.status === 'CLOSED' || !localAssign"
      >
        Assign
      </button>

      <button
        v-if="c.status != 'CLOSED'"
        class="danger"
        @click="$emit('close', c.conversation_id)"
        :disabled="c.status === 'CLOSED'"
      >
        Close
      </button>
    </div>

  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  c: Object,
  agents: Array
});

const emit = defineEmits(["view", "assign", "close"]);

const localAssign = ref("");

// reset when card changes
watch(() => props.c.conversation_id, () => {
  localAssign.value = "";
});

function assign() {
  emit("assign", {
    conversation_id: props.c.conversation_id,
    agent_id: localAssign.value
  });
}
</script>

<style scoped>
.conv-card {
  background: #f4f7fb;
  border-radius: 16px;
  padding: 18px;
  margin-bottom: 14px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.05);
  transition: 0.2s;
}

.conv-card:hover {
  transform: translateY(-2px);
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left {
  display: flex;
  gap: 8px;
  align-items: center;
}

.id {
  font-weight: 600;
}

.pill {
  padding: 3px 8px;
  border-radius: 8px;
  font-size: 12px;
  text-transform: uppercase;
}

.pill.OPEN { background: #e6f7ff; color: #1890ff; }
.pill.CLOSED { background: #ffe6e6; color: #ff4d4f; }

/* Right */
.right {
  font-size: 13px;
  color: #666;
}

/* User */
.user {
  margin-top: 10px;
  font-weight: 500;
}

/* Meta */
.meta {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

/* Message */
.message {
  margin-top: 10px;
  padding: 10px;
  background: #fff;
  border-radius: 10px;
  font-size: 14px;
  color: #333;
}

/* Actions */
.actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

button {
  padding: 6px 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

.secondary {
  background: #e6f0ff;
}

.danger {
  background: #ffe6e6;
  color: #d9363e;
}

select {
  padding: 6px;
  border-radius: 8px;
}
</style>